import {BACKEND_URL} from './api.service';

export const getMediaLink = (url) => {
  return `${BACKEND_URL}${url}`;
};